export const DEBOUNCE_TIME_PROTECTION = 500;